





























import { Vue, Component, Prop } from 'vue-property-decorator'
import type { FormLoja } from '@/models'
import CardDeAcoesDoPdv from '@/components/loja/CardDeAcoesDoPdv.vue'
import DialogoDePontoDeVenda from '@/components/loja/DialogoDePontoDeVenda.vue'

@Component({
	components: { CardDeAcoesDoPdv, DialogoDePontoDeVenda },
})
export default class SecaoPontosDeVenda extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja
	@Prop({ type: Boolean, default: true }) podeEditar!: boolean

	/** Os componentes de PDV recebem a loja com .sync; a troca da loja inteira sobe para a tela. */
	get lojaSincronizada() {
		return this.loja
	}

	set lojaSincronizada(loja: FormLoja) {
		this.$emit('update:loja', loja)
	}

	get pdvsOrdenados() {
		return [...this.loja.pdvs].sort((pdvA, pdvB) => pdvA.nome.localeCompare(pdvB.nome))
	}
}
